import ClassNames from "classnames";
import * as React from "react";

import Styles from "./Chip.module.css";

export interface Props {
  children: any;
  className?: string;
  small?: boolean;
  variant?: string;
}

const Chip: React.FC<Props> = props => {
  const { children, className, small, variant = "default" } = props;

  return (
    <span
      className={ClassNames({
        [Styles.chip]: true,
        [className]: className,
        [Styles.small]: small,
        [Styles[variant]]: true
      })}
    >
      {children}
    </span>
  );
};

export default Chip;
